import $ from 'jquery';
import 'jquery-zoom';
// import 'owl.carousel';
// import 'owl.carousel/dist/assets/owl.carousel.css';


export default
{

    init()
    {
        // JavaScript to be fired on single product page


    },


    finalize()
    {
        // JavaScript to be fired on single product page, after page specific JS is fired


        function product_carousel() {
            $('.single-product_photo_carousel').slick({
                autoplay: false,
                dots: true,
                arrows: false,
                adaptiveHeight: true,
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1
            }).on('afterChange', function () {
                let $img_product = $('.single-product_photo_carousel .slick-slide.slick-current.slick-active');
                $img_product.zoom({url: $img_product.find('img').attr('data-img-full')});
            }).slick('slickGoTo', 0);
        }

        if ($('.single-product_photo_carousel').length > 0) {
            product_carousel();
        }

        let show_variaton = (e) => {
            if($(".color").length <= 1) {
                return false;
            }

            let $e = $(e.target);

            let sku = $e.data("sku");
            // console.log("Attivo VAR", sku);

            // Cambio icona colore
            $e.siblings().removeClass("active");
            $e.addClass("active");

            // Cambio slider
            let sliders = $(".variation");
            let slider_selected = $(".variation[data-sku='" + sku + "']");

            sliders.toggleClass("d-none");

            $('.single-product_photo_carousel').slick('unslick');
            product_carousel();
        };


        // Handle selettore variazione
        $(".color").click(e => show_variaton(e));
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/singleProdotto.js